import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import * as Account from './Account';
import * as Login from './Login';
import * as ApplicationStore from './ApplicationStore';


export default function configureStore(initialState) { 

  const middleware = [
    thunk    
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const reducers = {
    account: Account.reducer,
    login: Login.reducer,
    app: ApplicationStore.reducer
  };

  const rootReducer = combineReducers({
    ...reducers    
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
